import Head from "next/head";
import Script from "next/script";
import { fetchGetBanners } from "../../../services/api";
import AboutUs from "../../components/about-us/about-us";
import SingleBanner from "../../components/default/single-banner";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import SocialMedia from "../../components/social-media/social-media";

export default function AboutUsPage({ companyGeneralData, banner }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={`${companyGeneralData.company.nickName} Revenda de veículos multimarcas, novos e semi-novos. Veículos com procedência e garantia.`} />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`${(companyGeneralData.company.nickName).toUpperCase()} - ${companyGeneralData.company.city ? companyGeneralData.company.city : ''} - Sobre Nós`}</title>
            </Head>

            <Script
                src="https://www.googletagmanager.com/gtag/js?id=AW-1777575901"
            />

            <Script
                id="gtag-base"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'AW-1777575901');
                `,
                }}
            />


            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <AboutUs company={companyGeneralData.company} />
                <SocialMedia company={companyGeneralData.company}/>
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps() {
    const banners = await fetchGetBanners({ idMenuOption: 2 });

    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null
        }
    }
}